import { LoanStatus, LoanStatusExternal } from '@nemuru-eng/js-api-client';

import { LoanStatusType } from '../types/loanStatusType';
import { OrderStatusType } from '../types/orderStatusType';

export const findNonActiveApplicationStatus: <T extends LoanStatusType[] | OrderStatusType[]>(
  statuses: T,
) => T[number] | undefined = (statuses) =>
  statuses?.find(
    (statusValue) =>
      statusValue.status === LoanStatus.STATUS_DENIED ||
      statusValue.status === LoanStatus.STATUS_EXPIRED ||
      statusValue.status === LoanStatus.STATUS_CANCELLED ||
      statusValue.status === LoanStatus.STATUS_CANCELLED_TEST ||
      statusValue.status === LoanStatus.STATUS_DESISTED ||
      statusValue.status === LoanStatusExternal.DENIED ||
      statusValue.status === LoanStatusExternal.DESISTED ||
      statusValue.status === LoanStatusExternal.CANCELLED ||
      statusValue.status === LoanStatusExternal.EXPIRED,
  );
